export default __webpack_public_path__ + "static/media/2.2a54dec5.jpg";